import { chakra } from "@chakra-ui/react"

const BackIcon = ({ fill = '#405D18', ...props }) => (
  <chakra.svg width={6} height={6} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M16.8 6.0001L10.8 12.0001L16.8 18.0001L15.6 20.4001L7.19995 12.0001L15.6 3.6001L16.8 6.0001Z" fill={fill} />
  </chakra.svg>
)

export default BackIcon
